export enum PLATFORM_TYPE {
  UNKNOWN = -1,
  iOS = 0,
  BROWSER = 1,
  ANDROID = 2,
  SONOS = 3,
  MQA_IOS = 4,
  MQA_ANDROID = 5,
  SONY_360_MQA_IOS = 6,
  SONY_360_IOS = 7,
  SONY_360_MQA_ANDROID = 8,
  SONY_360_ANDROID = 9
}

export const enum AUDIO_QUALITY {
  LOSSLESS = 'hifi',
  LOSSY = 'standard'
}

export const enum HTML5_PRELOAD_MODE {
  NONE = 'none',
  METADATA = 'metadata',
  AUTO = 'auto'
}

export const enum SDK_FLAGS {
  IS_AUTHORIZED = 'isAuthorized',
  IS_CHECKING = 'isChecking',
  IS_READY = 'isReady'
}

export const enum HASH_TYPE {
  SHA1 = 'SHA-1',
  SHA256 = 'SHA-256',
  SHA384 = 'SHA-384',
  SHA512 = 'SHA-512'
}

export const enum CRYPT_TYPE {
  AES_CTR = 'AES-CTR',
  AES_CBC = 'AES-CBC',
  AES_GCM = 'AES-GCM',
  RSA_OAEP = 'RSA-OAEP'
}

export const enum HTTP_METHOD {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS'
}

export const enum MIME_TYPE {
  APPLICATION_JSON = 'application/json',
  JSON = 'application/json',
  URLENCODED = 'application/x-www-form-urlencoded',
  MULTIPART = 'multipart/form-data'
}

export enum HTTP_STATUS_CODES {
  // 2** STATUS CODES
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  // 3** STATUS CODES
  MOVED_PERMANENTLY = 301,
  FOUND = 302,
  PERMANENT_REDIRECT = 308,
  // 4** STATUS CODES
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  PAYMENT_REQUIRED = 402,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  NOT_ALLOWED = 405,

  // 5** STATUS CODES
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504
}

export const enum ENV {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
  TESTING = 'testing'
}

export type LOG_THEME_SCHEMA = {
  bg: string,
  color: string,
  color2?: string
  border?: string
  borderRaduis?: string
}

export const LOG_THEME = {
  bg: '#000',
  color: '#fff',
  color2: '#000',
  border: 'none',
  borderRaduis: '2px'
} as LOG_THEME_SCHEMA
